// extracted by mini-css-extract-plugin
export default {"contentRefWrapper":"DisableAdsScreen__contentRefWrapper--dcxok"};